/**
 * The dimensions grid: [label][input] gap [label][input] on 36 columns. The button rows use it too,
 * so the alignment and rotate/flip buttons line up exactly with the inputs.
 */
export const GRID_COLUMNS = 36;
export const LABEL_XS = 3;
export const INPUT_XS = 14;
export const GAP_XS = 2;

// The buttons of a group fill its grid cell, with a gap between them
export const BUTTON_GROUP_SX = { display: 'flex', gap: 1 };
// Each button styled like the inputs; grey like Figma's icons: dark when usable, light when not
export const BUTTON_SX = {
  flex: 1,
  height: 36,
  p: 0,
  borderRadius: 0,
  bgcolor: 'others.lighter',
  color: 'neutral.dark',
  // The theme highlights a focused IconButton, so a clicked button would stay highlighted: only
  // show that for keyboard focus
  '&:focus': { bgcolor: 'others.lighter', color: 'neutral.dark' },
  '&:hover': { bgcolor: 'neutral.greyLight', color: 'neutral.dark' },
  '&.Mui-focusVisible': { bgcolor: 'primary.light', color: 'primary.dark' },
  '&.Mui-disabled': { color: 'neutral.light', bgcolor: 'others.lighter' },
  // The theme's MuiIconButton forces the icon to 24px; this selector overrides it
  '& .MuiSvgIcon-root': { width: 16, height: 16 },
};
